// extracted by mini-css-extract-plugin
export default {"stepsWrapper":"PlasmicSignupProgressBar_stepsWrapper__Fxfkh"};